import {Controller, useFormContext} from "react-hook-form";

import {ProcessSelect} from "views/ProcessDetails/refactor/components";
import {VoyageTypeService} from "util/globalEnums";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyageTypeServiceField = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();

  return (
    <Controller
      name={
        `boarding.voyages.${index}.typeService` as `boarding.voyages.0.typeService`
      }
      control={control}
      render={({field: {onChange, value}}) => (
        <ProcessSelect
          data={Object.values(VoyageTypeService)}
          label="Tipo de serviço"
          value={value ?? VoyageTypeService.NaoInformado}
          name={
            `boarding.voyages.${index}.typeService` as `boarding.voyages.0.typeService`
          }
          onChange={onChange}
          size="small"
          disabled={disabled}
        />
      )}
    />
  );
};

export default VoyageTypeServiceField;
